module.exports = __webpack_public_path__ + "img/bg28.02a827d8.png";